import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';
import { removeTagFromCache } from '~src/sidebar/index';
import { isLoggedUserGlobalEditor } from '~src/user';

export const deleteTagImage = async (imageId, tagId) => {
  $(`#btn-menu-frames #editor-btn-spinner-${tagId}`).show();
  $(`#delete-tag-${tagId}`).hide();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  let tableName;
  if (!isGlobalEditor) {
    tableName = 'editor_images';
  } else {
    tableName = 'editor_images_default';
  }

  const httpClient = await getAxiosClient();
  const url = `${process.env.PARSE_API_URL}/${tableName}/${imageId}`;
  const method = 'PUT';
  const data = {
    del_relations: [
      {
        column: 'tags',
        class: 'editor_images_tags',
        toIds: [tagId],
      },
    ],
  };
  try {
    await httpClient({ url, method, data: { data }, responseType: 'json' });
    removeTagFromCache(imageId, tagId);
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
